module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/clubs-27262c24f32962d2ae115e5130248ac7.jpg";